<template>
  <div :class="['member-bar',memberType.type]">
    <div class="header">
      <p class="vip-name">{{memberType.name}}</p>
      <p class="vip-price" v-if="!vipInfo.vipType">
        <span class="price">¥{{memberType.price}}</span>
        <span class="time">/年</span>
      </p>
      <p class="vip-price" v-else v-html="renewOrUpdate.price">
        <!-- <span :class="[renewOrUpdate.type === 'buy' ? 'price':'time']">{{renewOrUpdate.price}}</span> -->
      </p>
      <nuxt-link
        :to="'/member/' + memberType.type"
        class="buy"
        v-if="!vipInfo.vipType && isLessThenThreeMonths || (renewOrUpdate.type === 'buy' && isLessThenThreeMonths)"
      >立即开通</nuxt-link>
      <nuxt-link
        :to="'/member/' + (renewOrUpdate.type === 'buy' ? memberType.type : vipInfo.vipType)"
        class="buy"
        v-else
      >{{renewOrUpdate.btn}}</nuxt-link>
    </div>
    <ul class="equity-list">
      <li
        :class="['equity',{'is-active':item.vipTypes.indexOf(memberType.type)>=0}]"
        v-for="(item,index) in equity"
        :key="index"
      >
        <nuxt-link
          :to="'/member/privilegeintro#'+item.title"
        >{{item.title}}{{item[memberType.type+'Attach']}}</nuxt-link>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import * as api from '~/api/index';
import initTime from '~/plugins/initTime.js';

export default {
  props: {
    memberType: {
      type: Object,
      validator: function(value) {
        // 这个值必须匹配下列字符串中的一个
        return ['gold', 'platinum', 'ultimate'].indexOf(value.type) !== -1;
      }
    },
    equity: {
      type: Array
    }
  },
  data() {
    return {
      commodity: []
    };
  },
  computed: {
    ...mapGetters('user', ['vipInfo']),
    isLessThenThreeMonths() {
      if (this.vipInfo.vipExpireTimestamp) {
        let t = new Date().getTime() / 1000;
        return (this.vipInfo.vipExpireTimestamp - t) / 86400 < 90;
      } else {
        return true;
      }
    },
    renewOrUpdate() {
      let option = {
        gold: 0,
        platinum: 1,
        ultimate: 2
      };
      let msg = {
        price: '',
        btn: '',
        type: '',
        mPrice: ''
      };
      if (option[this.vipInfo.vipType] === option[this.memberType.type]) {
        msg.price = `<span class="time">${initTime(
          parseInt(this.vipInfo.vipExpireTimestamp) * 1000
        ).format('Y-M-D')}到期</span>`;
        msg.btn = '我要续费';
        msg.type = 'renew';
      } else if (option[this.vipInfo.vipType] > option[this.memberType.type]) {
        msg.price = `<span class="time">${initTime(
          parseInt(this.vipInfo.vipExpireTimestamp) * 1000
        ).format('Y-M-D')}到期</span>`;
        msg.btn = '我要续费';
        msg.type = 'disable';
      } else if (option[this.vipInfo.vipType] < option[this.memberType.type]) {
        msg.price = `<span class="price">¥${this.memberType.price}</span><span class="time">/年</span>`;
        msg.btn = '我要升级';
        msg.type = 'buy';
      }
      return msg;
    }
  },
  methods: {
    async getPurchaseList() {
      let res = await this.$axios(api.purchaseListV2(this.memberType.goodsId));
      // this.purchaseGoods = res & res.result ? res.result.purchaseGoods : [];
      if (res.statusCode === 403) return;
      let purchaseList = res.result.purchaseList || [];
      let r = purchaseList.filter(e => {
        return !!e.price;
      });
      this.commodity = r[0] || {};
    }
  },
  mounted() {
    this.getPurchaseList();
  },
  watch: {
    vipInfo: {
      deep: true,
      handler(v) {
        this.getPurchaseList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.member-bar {
  width: 360px;
  // height: 807px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  box-shadow: 0px 10px 26px 0px rgba(13, 27, 74, 0.12);
  .header {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-position: center;
    background-size: cover;
    height: 204px;
    width: 100%;
    color: #fff;
    p {
      text-align: center;
      text-shadow: rgba(13, 27, 74, 0.22) 2px 1px 4px;
    }
    .vip-name {
      font-size: 24px;
      font-weight: 400;
      line-height: 74px;
    }
    .vip-price {
      height: 40px;
      overflow: hidden;
      margin-bottom: 33px;
      .price {
        font-size: 40px;
      }
      .time {
        font-size: 20px;
        line-height: 40px;
      }
    }
    .buy {
      text-align: center;
      cursor: pointer;
      width: 135px;
      height: 36px;
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 36px;
      background-color: rgba(204, 204, 204, 0);
      margin: 0 auto;
      display: block;
    }
  }
  .equity-list {
    .equity {
      cursor: pointer;
      width: 360px;
      height: 46px;
      background: rgba(255, 224, 170, 0.1);
      line-height: 46px;
      text-align: center;
      position: relative;
      &:nth-child(odd) {
        background: rgba(255, 255, 255, 1);
      }
      &:hover {
        box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.05);
        z-index: 10;
      }
      a {
        color: rgba(153, 153, 153, 1);
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .is-active {
      a {
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.gold {
  .header {
    background-image: url(https://cdn.gelonghui.com/static/web/gold-card.png);
    background-color: #ffd38e;
  }
}
.platinum {
  .header {
    background-image: url(https://cdn.gelonghui.com/static/web/platinum-card.png);
    background-color: #bfbcff;
  }
}
.ultimate {
  .header {
    background-image: url(https://cdn.gelonghui.com/static/web/ultimate-card.png);
    background-color: #000;
    p {
      color: transparent;
      background: linear-gradient(
        0deg,
        rgba(205, 155, 114, 1) 0%,
        rgba(244, 199, 173, 1) 100%
      );
      background-size: cover;
      -webkit-background-clip: text;
    }
    .buy {
      width: 135px;
      height: 36px;
      background: rgba(216, 166, 130, 1);
      border-radius: 4px;
      font-size: 18px;
      font-weight: 400;
      color: rgba(88, 46, 14, 1);
      line-height: 36px;
      border: none;
    }
  }
}
</style>
<style>
.member-bar .vip-price .price {
  font-size: 40px;
}
.member-bar .vip-price .time {
  font-size: 20px;
  line-height: 40px;
}
</style>
